import Esptool from '../drivers/esptool/index';

let current = null;

// 将回调封装一层，用于辨别是那一次请求的回调，只执行当前请求的回调函数
class HandleCallback {
    constructor() {
        this.tag = new Date().getTime();
    }

    call(tag, cb, error, fn) {
        console.warn(`current: ${current} Or this.tag: ${tag}`);
        if (current === tag) {
            cb(error, fn);
        }
    }

    progress(tag, pg, num) {
        console.warn(`current: ${current} Or this.tag: ${tag}`);
        if (current === tag) {
            pg(num);
        }
    }
}

let firmware = async function (serialPort, data, progressHandle, callback) {
    const handler = new HandleCallback();
    current = handler.tag;
    try {
        const esptool = new Esptool(serialPort, data, handler.progress, progressHandle, current);
        esptool.bootLoad(handler.call, callback);
    } catch (e) {
        console.warn(e);
        callback('new esp drivers fail.')
    }
};

export default firmware;